"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var useConfigContext_1 = require("../useConfigContext/useConfigContext");
var helpers_1 = require("./helpers");
var convert_units_1 = __importDefault(require("convert-units"));
var numeral_1 = __importDefault(require("numeral"));
exports.useLocalUnit = function (config) {
    var defaultProps = {
        decimalPlaces: 2,
        showUnits: false,
        showAbbreviation: false
    };
    var props = __assign(__assign({}, defaultProps), config);
    var value = props.value, defaultUnit = props.defaultUnit, metricUnit = props.metricUnit, imperialUnit = props.imperialUnit, showAbbreviation = props.showAbbreviation, decimalPlaces = props.decimalPlaces;
    var measurementUnits = useConfigContext_1.useConfigContext().measurementUnits;
    var rawValue;
    if (measurementUnits === 'metric') {
        rawValue = convert_units_1.default(value).from(defaultUnit).to(metricUnit || defaultUnit);
    }
    else if (measurementUnits === 'imperial') {
        rawValue = convert_units_1.default(value).from(defaultUnit).to(imperialUnit || defaultUnit);
    }
    else {
        rawValue = value;
    }
    if (showAbbreviation) {
        var formatString = '0.';
        if (decimalPlaces) {
            formatString += '0'.repeat(decimalPlaces);
        }
        formatString += 'a';
        return numeral_1.default(rawValue).format(formatString).toUpperCase() + helpers_1.genLabel(config, measurementUnits);
    }
    return helpers_1.setDecimalPlaces(rawValue, decimalPlaces) + helpers_1.genLabel(config, measurementUnits);
};
